import React from "react"
import { AppToolbarCreateButton } from "@components"

import { useUserSettingsSite } from "../../@hooks"


export default function UserSettingsSitesTabButton() {

    const { handleSetSitesFormData } = useUserSettingsSite()

    return <AppToolbarCreateButton
        label="Define Sites Color"
        onClick={handleSetSitesFormData}
    />
}